import React, { useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { get } from "lodash";
import { normalizePrismicHempRetailers } from "../../helpers/customHempRetailers";

const CustomHempRetailers = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: "PRISMIC_LOAD_SINGLE_PAGE",
      key: "custom_hemp_retailers_list",
    });
  }, [dispatch]);

  const dataLoading = useSelector((state) =>
    get(state, "prismic.custom_hemp_retailers_list.loading", true),
  );
  const data = useSelector((state) =>
    get(state, "prismic.custom_hemp_retailers_list.data", false),
  );
  const customStores = useMemo(
    () => normalizePrismicHempRetailers(data),
    [data],
  );

  if (typeof children !== "function") {
    return null;
  }

  return children({
    customStores,
    customStoresLoading: dataLoading,
  });
};

export default CustomHempRetailers;
